import React, { useState } from 'react'
import { LogoutOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import s from './LoggedUser.module.css'
import { Dropdown, Space, Avatar } from 'antd'
import { useAppDispatch, useAppSelector } from '@/shared/types'
import { RoutesPath } from '@/shared/types/RoutesPath'
import { useLogoutMutation } from '@/entities/session/api/sessionApi'
import { selectUserMe } from '@/entities/session/model/slice'
import { persistedStore } from '@/app/store/appStore'

const getInitials = str => {
  if (!str) return 'W S'
  const words = str.split(' ')
  const initials = words.map(word => word.charAt(0).toUpperCase()).join('')
  return initials
}

const LoggedUser = () => {
  const navigate = useNavigate()
  const me = useAppSelector(selectUserMe)
  const [logout] = useLogoutMutation()

  const handleLogout = () => {
    logout()
    // navigate(RoutesPath.LOGIN)
  }

  const items = [
    {
      label: (
        <p onClick={handleLogout}>
          {' '}
          <LogoutOutlined /> {'Logout'}
        </p>
      ),
      key: '0',
    },
  ]

  return (
    <div className={s.container}>
      <Dropdown
        menu={{
          items,
        }}
        trigger={['click']}
      >
        <a onClick={e => e.preventDefault()} href='#/'>
          <Space>
            <Avatar
              size={40}
              color={'rgb(83, 133, 249)'}
              title={me?.name || 'User'}
              style={{ background: '#4fcdff' }}
            >
              {getInitials(me?.name)}
            </Avatar>
          </Space>
        </a>
      </Dropdown>
    </div>
  )
}

export default LoggedUser
